

































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { isAndroid, login } from "@/services/auth-service";
import {
  errorToast,
  warningToast,
} from "water-layout/src/services/toastr-service";
import {mapGetters} from "vuex";
import {ThemeConfig} from "@/model/config/ThemeConfig";
import {themeBg} from "@/assets/themeBg";
import {setGlobalThemeType, ThemeType} from "@/services/theme-service";
import DownloadAppModal from "@/components/modal/DownloadAppModal.vue";

@Component({
  computed: {...mapGetters('themeModule', ['themeConfig'])}
})
export default class Login extends Vue {
  themeConfig!: ThemeConfig;

  private username: string | null = "";
  private password: string | null = "";
  private isAuthenticating = false;
  private rememberMe = false;
  private isForeign = false;
  private isMouseOnForm = false;
  get formTitle() {
    return this.themeConfig.loginFormTitle;
  }
  get copyrightText() {
    return this.themeConfig.copyrightText ?? '©<br>АО «Росатом Инфраструктурные решения»';
  }
  private isShowError = false;
  get isMultiTheme() {
    return this.themeConfig.themeName === 'multi';
  }
  get isShowTopLogo() {
    return this.themeConfig.showLoginPageTopLogo;
  }

  @Watch('isForeign', { immediate: true }) onIsForeign(status: boolean) {
    this.$store.commit('setIsForeign', status);
  }

  created() {
    this.$rir.changeTheme('default');
    const body = document.querySelector("body");
    body && body.classList.remove("menu-left");
  }

  get rawLogo(): boolean {
    return process.env.VUE_APP_RAW_LOGO === "true";
  }

  get copyrightYears() {
    const yearForm = this.themeConfig.copyrightYearFrom || 2020;
    const currentYear = new Date().getFullYear();
    if (currentYear > yearForm) {
      return `${yearForm} - ${currentYear}`;
    }
    return `${currentYear}`;
  }

  get theme() {
    const theme: Record<string, string | null> = {bgImg: null, topLeftLogo: null, topCenterLogo: null, topRightLogo: null, formLogo: null};

    if ( !this.themeConfig.themeName ) return theme;

        /** Поведение анимации настроено на css-классах непосредственно внутри svg-файла
         Активация анимации - установка класса `animate-active` на любом вышестоящем элементе (выше svg) **/
      theme.bgImg = themeBg[this.themeConfig.themeName || "water"];

    if (this.isShowTopLogo) {
        theme.topCenterLogo = `/themes/${this.themeConfig.themeName}/login-page-top-logo.svg`;
        if ( this.themeConfig.showLoginPageSideLogo ) {
          theme.topLeftLogo = `/themes/${this.themeConfig.themeName}/login-page-top-left-logo.svg`;
          theme.topRightLogo = `/themes/${this.themeConfig.themeName}/login-page-top-right-logo.svg`;
        }
    }

    if (!this.formTitle && !this.themeConfig.hideLoginPageLogo) {
        theme.formLogo = `/themes/${this.themeConfig.themeName}/login-page-logo.svg`;
    }

    return theme;
  }

  get isValidUserName() {
    const { username } = this;

    if (username) {
      return (username.length > 0 && username.length < 101)
    }

    return false;
  }

  get isValidPassword() {
    const { password } = this;

    if (password) {
      return (password.length > 0 && password.length < 101)
    }

    return false;
  }

  getCopyrightText() {
    return `${this.copyrightYears} ${this.copyrightText}`;
  }

  /**
   * Обработка нажатия кнопи Enter в форме аутентификации
   * */
  onKeyPress(event: any) {
    const { which, keyCode } = event;
    if ((which === 13 || keyCode === 13) && !this.loginBtnDisabled) {
      this.authenticate();
    }
  }

  onMouseEnter() {
    this.isMouseOnForm = true;
  }
  onMouseLeave() {
    this.isMouseOnForm = false;
  }

  authenticate() {
    const { username, password } = this;

    this.isShowError = true;

    if (this.loginBtnDisabled || !username || !password || !this.isValidUserName || !this.isValidPassword || this.isAuthenticating) return;

    this.isAuthenticating = true;
    login(username, password)
      .then(() => {
        this.isAuthenticating = false;
      })
      .catch(async (error: any) => {
        if ((await error).message?.length) {
          errorToast((await error).message);
        } else {
          if (error.status === 401) {
            warningToast("Неправильный логин или пароль");
          } else if (error.status === 403) {
            warningToast("Отсутствует разрешение на вход");
          } else {
            errorToast("Ошибка аутентификации. Пожалуйста, повторите попытку позже");
          }
        }
        this.isAuthenticating = false;
      });
  }

  get loginBtnDisabled(): boolean {
    const { username, password } = this;
    return !this.isValidUserName || !this.isValidPassword;
  }

  toDownloadApp() {
    if (isAndroid()) { // Страница для мобильного Android браузера
      this.$router.push('/download-app');
    } else { // Модальное окно с QR кодами на скачивание Приложения и Настроек
      this.$rir.modal.open(DownloadAppModal, {
        emptyProps: true,
      });
    }
  }
}
